import React from 'react';
import { FaWhatsapp, FaFacebook, FaTwitter, FaTelegram } from 'react-icons/fa';
import { useTheme } from '../../context/ThemeContext';
import { Transition, Dialog } from '@headlessui/react';
import { Fragment } from 'react';
import toastService from '../../services/toast';

const ShareModal = ({ isOpen, onClose, courseUrl }) => {
  const shareOnPlatform = (platform, url) => {
    window.open(url, '_blank');
    onClose();
  };

  const copyToClipboard = () => {
    navigator.clipboard.writeText(courseUrl);
    toastService.success('تم نسخ الرابط ');
  };

  const { theme } = useTheme();
  const textColor = theme === 'dark' ? 'text-gray-200' : 'text-gray-700';

  return (
    <Transition appear show={isOpen} as={Fragment}>
      <Dialog
        as="div"
        className="fixed inset-0 z-50 overflow-y-auto"
        onClose={onClose}
      >
        <div className="min-h-screen px-4 text-center">
          {/* هذه الطبقة ستظهر خلف المودال مباشرة */}
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <Dialog.Overlay className="fixed inset-0 bg-black/25 backdrop-blur-sm" />
          </Transition.Child>

          {/* هذه العنصر للمحاذاة الرأسية */}
          <span 
            className="inline-block h-screen align-middle" 
            aria-hidden="true"
          >
            &#8203;
          </span>

          {/* محتوى المودال الرئيسي */}
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0 scale-95"
            enterTo="opacity-100 scale-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100 scale-100"
            leaveTo="opacity-0 scale-95"
          >
            <div className="inline-block w-full max-w-md my-8 overflow-hidden text-left align-middle transition-all transform bg-white dark:bg-gray-800 shadow-xl rounded-lg relative z-50">
              <div className="px-6 py-4">
                <div className="text-center mb-8">
                  <div className="mb-4">
                    <div className="flex justify-center">
                      <svg className="h-12 w-12 text-blue-500" viewBox="0 0 20 20" fill="currentColor">
                        <path d="M15 8a3 3 0 10-2.977-2.63l-4.94 2.47a3 3 0 100 4.319l4.94 2.47a3 3 0 10.895-1.789l-4.94-2.47a3.027 3.027 0 000-.74l4.94-2.47C13.456 7.68 14.19 8 15 8z" />
                      </svg>
                    </div>
                  </div>
                  <h3 className="text-lg font-semibold mb-4">شارك هذه الدورة مع أصدقاءك</h3>
                </div>
                <div className="flex justify-center items-center gap-0 mb-4">
                  <div className="bg-gray-200 dark:bg-gray-700 rounded-r-lg rounded-l-none shadow px-4 py-2">
                    <span className={`${textColor} font-medium text-sm`}>
                      {courseUrl}
                    </span>
                  </div>
                  <button
                    onClick={copyToClipboard}
                    className="px-4 py-2 bg-blue-500 text-white rounded-l-lg rounded-r-none hover:bg-blue-600 transition-colors"
                  >
                    نسخ
                  </button>
                </div>
                <div className="text-center mb-8">
                  <span className="text-sm">اضغط على الأيقونة لمشاركة الدورة مباشرة</span>
                </div>
                <div className="grid grid-cols-4 mb-8">
                  <div className="flex flex-col items-center">
                    <button
                      onClick={() => shareOnPlatform('WhatsApp', `https://wa.me/?text=${encodeURIComponent(courseUrl)}`)}
                      className="text-3xl text-green-500 hover:text-green-600 transition-colors duration-200"
                      title="واتساب"
                    >
                      <FaWhatsapp />
                    </button>
                    <span className="text-xs mt-1">واتساب</span>
                  </div>
                  <div className="flex flex-col items-center">
                    <button
                      onClick={() => shareOnPlatform('Facebook', `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(courseUrl)}`)}
                      className="text-3xl text-blue-600 hover:text-blue-700 transition-colors duration-200"
                      title="فيسبوك"
                    >
                      <FaFacebook />
                    </button>
                    <span className="text-xs mt-1">فيسبوك</span>
                  </div>
                  <div className="flex flex-col items-center">
                    <button
                      onClick={() => shareOnPlatform('Twitter', `https://twitter.com/intent/tweet?url=${encodeURIComponent(courseUrl)}`)}
                      className="text-3xl text-blue-400 hover:text-blue-500 transition-colors duration-200"
                      title="تويتر"
                    >
                      <FaTwitter />
                    </button>
                    <span className="text-xs mt-1">تويتر</span>
                  </div>
                  <div className="flex flex-col items-center">
                    <button
                      onClick={() => shareOnPlatform('Telegram', `https://t.me/share/url?url=${encodeURIComponent(courseUrl)}`)}
                      className={`text-2xl ${textColor} hover:text-blue-500 transition-colors duration-200`}
                      title="تيليجرام"
                    >
                      <FaTelegram />
                    </button>
                    <span className="text-xs mt-1">تيليجرام</span>
                  </div>
                </div>
                <div className="text-center">
                  <button
                    onClick={onClose}
                    className="px-6 py-2 bg-red-500 text-white rounded hover:bg-red-600 transition-colors"
                  >
                    إغلاق
                  </button>
                </div>
              </div>
            </div>
          </Transition.Child>
        </div>
      </Dialog>
    </Transition>
  );
};

export default ShareModal;